import { CognitoUser } from 'amazon-cognito-identity-js';

export function rememberNewDevice(user: CognitoUser): Promise<{ status: boolean; error?: string }> {
  return new Promise(resolve => {
    user?.setDeviceStatusRemembered({
      onSuccess: () => resolve({ status: true }),
      onFailure: (err: Error) => {
        resolve({ status: false, error: err.message });
      },
    });
  });
}
